export default __webpack_public_path__ + "static/media/logo2.f825d30e.png";